export const getSharedKey = (key: string) => `shared.${key}`
export const getLkGeneralKey = (key: string) => `lkGeneral.${key}`
export const getUserModuleKeys = (key: string) => `lkGeneral.${key}`
